module.exports = __webpack_public_path__ + "img/bp_button_pre_zjcx.d3ef6515.png";